import { inServer } from "core-web/constants";
import variables from "theme/config/variables";

const getNavResponsiveProps = (searchOpen, isInCheckout, customTopMargin) => {
    if (inServer) {
        return {};
    }

    const searchInputHeightMobile = searchOpen ? variables.searchInputHeightMobile : 0;
    const searchInputHeightTablet = searchOpen ? variables.searchInputHeightTablet : 0;

    //Overlay outline top/bottom margins
    const tabletYMargin = 6 + 6;
    const mobileYMargin = 6 + 6;
    const desktopYMargin = 6 + 8;

    const topMarginSmall = customTopMargin || 6;
    const topMarginLarge = customTopMargin || 6;

    const mobile = variables.headerHeightMobile;
    const tablet = variables.headerHeightTablet;
    const desktop = variables.headerHeight;

    const defaultTop = [
        `${mobile + searchInputHeightMobile + topMarginSmall}px`,
        null,
        `${tablet + searchInputHeightTablet + topMarginSmall}px`,
        null,
        `${desktop + topMarginLarge}px`,
    ];

    const defaultHeight = [
        `calc(100% - ${mobile + searchInputHeightMobile + mobileYMargin}px)`,
        null,
        `calc(100% - ${tablet + searchInputHeightTablet + tabletYMargin}px)`,
        null,
        `calc(100% - ${desktop + desktopYMargin}px)`,
    ];

    const height = isInCheckout ? `calc(100% - ${variables.checkoutHeaderHeight + 16}px)` : defaultHeight;
    const top = isInCheckout ? `${variables.checkoutHeaderHeight + 8}px` : defaultTop;

    return { top, height };
};

export default getNavResponsiveProps;
